import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 4fr 4fr 4fr 1fr',
    color: 'gray',
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    color: 'gray',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,

    borderRadius: 12,
    alignItems: 'center'
  },
  tableRowRoot: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '20fr 1fr',
    transition: 'background-color 0.3s ease-in-out',
    height: 100,
    marginBottom: 4,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    textAlign: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRow: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '4fr 4fr 4fr 4fr 4fr',
    height: 100,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    marginBottom: 4,
    textAlign: 'unset'
  },
  tableRowSkeleton: {
    gridTemplateColumns: '6fr 4fr 4fr 1fr'
  },
  tableRowMobile: {
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'initial',
    paddingLeft: 12,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: theme.palette.grey[400],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    display: 'flex'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '80%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  },
  rowMenu: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  rowMenuItemAPIKey: {
    color: theme.palette.grey[800]
  }
}))

export default useStyles
